import { separatorRe } from './regex';
import { each, trim, endsWith, findIndex, join, filter, } from 'lodash';
import { isDomain } from './validate';
import { BLACK_DOMAINS } from '@/constants/domain';
export function trySplitDomains(domainStr = '') {
    const domains = domainStr.split(separatorRe);
    const fixedDomains = [];
    each(domains, domain => {
        domain = trim(domain);
        if (domain) {
            domain = domain.toLowerCase();
            fixedDomains.push(domain);
        }
    });
    return fixedDomains;
}
export function matchDomain(domain, targetDomain) {
    return endsWith(domain, targetDomain);
}
export function validateDomains(domains) {
    const domainArray = trySplitDomains(domains);
    for (let i = 0, len = BLACK_DOMAINS.length; i < len; i++) {
        const blackDomain = BLACK_DOMAINS[i];
        if (findIndex(domainArray, domain => matchDomain(domain, blackDomain)) !== -1) {
            const blackDomains = join(BLACK_DOMAINS, ',');
            /* 这里的思路应该是如果有一个不正确，则验证失败，并显示错误信息 */
            return {
                validated: false,
                domains: blackDomains,
                blackDomains,
            };
        }
        const invalidDomains = filter(domainArray, domain => !isDomain(domain));
        if (invalidDomains.length > 0) {
            return {
                validated: false,
                invalidDomains,
            };
        }
    }
    return {
        validated: true,
        domains: domainArray,
    };
}
export function validateDomain(domain) {
    if (!isDomain(domain)) {
        return {
            validated: false,
            invalidDomain: domain,
        };
    }
    return {
        validated: true,
        domain: domain,
    };
}
